export default __webpack_public_path__ + "static/media/global.9e95f8f7.png";